import Client from '@/models/Client'

const state = {
  client: Client.from(localStorage.currentClient),
  temp_client: Client.from(localStorage.tempCurrentClient),
  clients: []
}

const getters = {
  currentClient (state) {
    return state.client
  },
  clients (state) {
    return state.clients
  },
  tempCurrentClient (state) {
    return state.temp_client
  }
}

const mutations = {
  setCurrentClient (state, client) {
    state.client = new Client(client)
    state.client.current = true
    var currentClient = JSON.stringify(client)
    localStorage.currentClient = currentClient
    localStorage.tempCurrentClient = null
  },
  setTempCurrentClient (state, client) {
    state.client = new Client(client)
    var tempCurrentClient = JSON.stringify(client)
    localStorage.tempCurrentClient = tempCurrentClient
    setTimeout(function(){
      localStorage.tempCurrentClient = null
    }, 5000)
  },
  setClients (state, clients) {
    state.clients = clients
  }
}

export default {
  state,
  getters,
  mutations
}
